<template>
  <Loader
    v-if="storeLoader.load[3]"
    :loader="storeLoader.load[3]"
    loaderSize="h-28"
    spinnerSize="small"
  />
  <div id="materials" v-else-if="storeMaterial.materials?.length !== 0">
    <div
      v-for="(material, materialIndex) in storeMaterial.materials"
      :key="materialIndex"
    >
      <ButtonAccordion :data="material" :index="materialIndex" isMaterial />
    </div>
  </div>
</template>

<script lang="ts">
import { useLoaderStore } from "@/store/linear/loader";
import { useMaterialStore } from "@/store/linear/material";
import { useVideoStore } from "@/store/video";
import { defineAsyncComponent, defineComponent, watch } from "vue";

const ButtonAccordion = defineAsyncComponent(
  () => import("./button-accordion.vue")
);

export default defineComponent({
  name: "SidebarMaterials",
  components: { ButtonAccordion },
  setup() {
    const storeMaterial = useMaterialStore;
    const storeLoader = useLoaderStore;
    const storeVideo = useVideoStore;

    watch(
      () => storeMaterial.materials,
      (val) => (storeMaterial.materials = val),
      { deep: true }
    );

    watch(storeVideo, (val) => {
      if (val.getVideoEnded === true) storeMaterial.materialEvent();
    });

    return { storeLoader, storeMaterial };
  },
});
</script>
